import { render, staticRenderFns } from "./switch-account.vue?vue&type=template&id=344ba47c&scoped=true"
import script from "./switch-account.vue?vue&type=script&lang=js"
export * from "./switch-account.vue?vue&type=script&lang=js"
import style0 from "./switch-account.vue?vue&type=style&index=0&id=344ba47c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ba47c",
  null
  
)

export default component.exports